// Import helpers
import {
	ALL_OPERATORS,
	PACKETS_OPERATORS,
	CONFIGURATOR_OPERATORS,
	DVR_RECORDINGS_OPERATORS
} from 'helpers/operators';

// Import variables
import { TV_PATHS } from 'components/routes/tv_routes/paths';
import { URL_CONFIGURATOR } from '../views/configurator/helpers';

const { INTRODUCE_DECODER } = TV_PATHS;

export const NAV_LINKS = [
	{
		slug: 'Start',
		name: 'start',
		id: 'start',
		path: '/tv/strona-glowna',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'Telewizja',
		name: 'tv',
		id: 'tv',
		path: '/tv/telewizja',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'Program TV',
		name: 'epg',
		id: 'epg',
		path: '/tv/epg',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'VOD',
		name: 'vod',
		id: 'vod',
		path: '/vod/filmy',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: 'KIDS',
		name: 'kids',
		id: 'kids',
		path: '/vod/dla-dzieci',
		translationSection: 'header_nav',
		operators: ALL_OPERATORS
	},
	{
		slug: '',
		name: 'recordings',
		id: 'recordings',
		path: '/tv/nagrania',
		translationSection: 'header_nav',
		operators: DVR_RECORDINGS_OPERATORS
	},
	{
		slug: 'Pakiety',
		name: 'packets',
		id: 'packets',
		path: '/pakiety',
		translationSection: 'header_nav',
		operators: PACKETS_OPERATORS
	},
	{
		slug: 'Poznaj dekoder 4K Box',
		name: 'decoder',
		id: 'decoder',
		path: INTRODUCE_DECODER,
		translationSection: 'header_nav',
		operators: CONFIGURATOR_OPERATORS
	},
	{
		slug: 'Konfigurator',
		name: 'configurator',
		id: 'configurator',
		path: URL_CONFIGURATOR,
		state: { slide: 0, selectedMainPacket: null },
		translationSection: 'header_nav',
		itemModifiers: 'distinctive',
		navLinkModifiers: 'distinctive',
		operators: CONFIGURATOR_OPERATORS
	}
];
